import styled from 'styled-components'

export const Root = styled.div`
  display: flex;
  align-items: center;
`

export const Content = styled.div`
  flex: 1 0;
  min-width: 0;

  ${({ theme }) => `
    color: ${theme.color.white};
    margin-left: ${theme.space.mobile.base};
  `}
`

export const Name = styled.div`
  h3 {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`
